import { render } from "./ServiceTargets.vue?vue&type=template&id=636d0ecc&scoped=true"
import script from "./ServiceTargets.vue?vue&type=script&lang=js"
export * from "./ServiceTargets.vue?vue&type=script&lang=js"

import "./ServiceTargets.vue?vue&type=style&index=0&id=636d0ecc&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636d0ecc"]])

export default __exports__